import { is } from '../util/is';
import { Foldable } from '../types/foldable';

/**
 * Takes a function of type `A -> B -> A` and a [[Foldable]] of type `F<B>` and returns a summary value of type `A`.
 *
 * @param fn A function that takes an accumulator and a value and combines them.
 * @param acc The starting value of the accumulator to be combined with elements of the `f`.
 * @param f A [[Foldable]] to be reduced to a summary value.
 */
export function reduce<A, B>(fn: (acc: A, v: B, keyOrIndex: number | string) => A, acc: A, f: Foldable<B>): A {
  let out = acc;

  if (is(Array, f)) {
    for (let i = 0, n = (f as B[]).length; i < n; i++) {
      const el = (f as B[])[i];
      out = fn(out, el, i);
    }
  } else {
    for (const k in f) {
      out = fn(out, (f as Record<string, B>)[k], k);
    }
  }

  return out;
}
